import React, { createContext, useContext } from 'react';
import { Pagination } from '@/Models/Page';
import { useShortlistedProfiles } from '../../../api/useShortlistedProfiles';
import usePagination from '@/Hooks/usePagination/usePagination';

export interface ShortlistedListContextType extends ReturnType<typeof useShortlistedProfiles> {
    pagination: Pagination;
    setPagination: React.Dispatch<React.SetStateAction<Pagination>>;
}

export const ShortlistedListContext = createContext<ShortlistedListContextType>(undefined!);

export const useShortlistedListContextProvider = () => {
    const [pagination, setPagination] = usePagination();
    const shortlistedProfiles = useShortlistedProfiles(pagination.limit, pagination.offset);

    return {
        pagination,
        setPagination,
        ...shortlistedProfiles,
    };
};

export const useShortlistedListContext = () => {
    const context = useContext(ShortlistedListContext);

    if (!context) {
        throw new Error('useShortlistedListContext must be used inside ShortlistedListContextProvider');
    }

    return context;
};
